import React, { useEffect, useState } from 'react';
import './Project.css';
import { useParams } from 'react-router';
import Slider from 'react-slick';
import ProjectDetails from '../ProjectDetails/ProjectDetails';
import TechContainer from '../TechContainer/TechContainer';

const Project = () => {
        const { projectId } = useParams();
        const [projects, setProjects] = useState([]);

        // Load Data From API:
        useEffect(() => {
                fetch('/projects.json')
                        .then(res => res.json())
                        .then(data => setProjects(data))
        }, []);

        // Filter Single Project:
        const project = projects?.find(project => project?.id === +projectId);

        const settings = {
                dots: true,
                infinite: true,
                speed: 500,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3000,
        };
        return (
                <div className="container mt-5 pt-5 mb-5">
                        <div className="project-card container mt-4">
                                <div className="">
                                        <div className="row">
                                                <div className="col-lg-8 col-md-8 col-12 mx-auto pt-5">
                                                        <div className="brand-border">
                                                                <Slider {...settings}>
                                                                        <div>
                                                                                <img className="img-fluid border border-3 brand-border  border-dark" src={project?.img1} alt="" />
                                                                        </div>
                                                                        <div>
                                                                                <img className="img-fluid border border-3 brand-border  border-dark" src={project?.img2} alt="" />
                                                                        </div>
                                                                        <div>
                                                                                <img className="img-fluid border border-3 brand-border border-dark" src={project?.img3} alt="" />
                                                                        </div>
                                                                </Slider>
                                                        </div>
                                                </div>
                                                <div className="row">
                                                        <div className="text-center brand-color ms-3 fw-bold">
                                                                <div>
                                                                        <small style={{

                                                                        }} className="d-block m-0 p-0">__________
                                                                        </small>
                                                                        <small className="d-block m-0 p-0">________________</small>
                                                                        <small className="d-block m-0 p-0">_________________________</small>
                                                                </div>
                                                        </div>
                                                </div>
                                                <div className="row mt-5 pt-5">
                                                        <div className="col-lg-8 col-md-8 col-12 mx-auto p-3">
                                                                <div className="row">
                                                                        <div className="col-lg-4 d-flex align-items-center">
                                                                                <h4 className="fw-bold">Project Name:</h4>
                                                                        </div>
                                                                        <div className="col-lg-8 col-md-8 col-12">
                                                                                <h2 className="brand-color fw-bold">{project?.name}</h2>
                                                                        </div>
                                                                </div>
                                                                <div className="row mt-3">
                                                                        <div className="col-lg-4 d-flex align-items-center">
                                                                                <h4 className="fw-bold">Technologies:</h4>

                                                                        </div>
                                                                        <div className="col-lg-8 col-md-8 col-12">
                                                                                {
                                                                                        project?.technologies?.map(tec =>
                                                                                                <TechContainer
                                                                                                        tec={tec}
                                                                                                >

                                                                                                </TechContainer>)
                                                                                }
                                                                        </div>
                                                                </div>
                                                                <div className="row mt-3">
                                                                        <div className="col-lg-4 col-md-12 col-12 d-flex align-items-center">
                                                                                <h4 className="fw-bold">Links:</h4>
                                                                        </div>
                                                                        <div className="col-lg-8 col-md-8 col-sm-12 col-12 d-flex">
                                                                                <div>
                                                                                        {/* <a href={project?.live} target="_blank">
                                                                                                <button className="btn code-btn text-white fw-bolder d-inline-block me-sm-0 me-md-3 me-lg-3">
                                                                                                        <i className="fas fa-globe"></i> Website
                                                                                                </button>
                                                                                        </a> */}
                                                                                        <a className="special-btn" href={project?.live} target="_blank">
                                                                                                <span>Website</span> <i></i></a>
                                                                                </div>
                                                                                <div>
                                                                                        {/* <a href={project?.github_client} target="_blank">
                                                                                                <button className="btn code-btn text-white fw-bolder d-inline-block">
                                                                                                        <i className="fab fa-github"></i> GitHub
                                                                                                </button>
                                                                                        </a> */}
                                                                                        <a className="ms-2 special-btn" href={project?.github_client} target="_blank">
                                                                                                <span>GitHub</span> <i></i></a>
                                                                                </div>
                                                                        </div>
                                                                </div>
                                                        </div>




                                                        <div className="row mt-5">
                                                                <div className="col-lg-10 col-md-10 col-12 mx-auto">
                                                                        <ProjectDetails
                                                                                project={project ? project : ''}
                                                                        ></ProjectDetails>
                                                                </div>
                                                        </div>
                                                </div>
                                        </div>
                                </div>
                        </div >
                </div>
        );
};

export default Project;